<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
    />
    <PartyForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import PartyForm from '../../components/party/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'Party';

export default {
  name: 'PartyUpdate',
  servicePrefix,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    PartyForm
  },

  computed: {
    ...mapFields('party', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('party', ['find'])

  },

  methods: {
    ...mapActions('party', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),
    resetForm() {
      this.$refs.updateForm.$v.$reset();
      this.item = { ...this.retrieved };
      this.item.sepaInfo = { ...this.retrieved.sepaInfo };
    }
  },

  watch: {
    retrieved(val) {
      this.item = { ...val };
      this.item.sepaInfo = { ...val.sepaInfo };
    }
  }
};
</script>
